import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import LOGO_PATH from "@/assets/images/headerLogo.svg";
import TT_LOGO_PATH from "@/assets/images/tt-qrcode.png";
import ICON_MEITUAN from "@/assets/images/icon-meituan.png";
import ICON_MEITUAN_WHITE from "@/assets/images/icon-meituan-white.png";
import ICON_DAXIANG from "@/assets/images/icon-daxiang.png";
import ICON_DAXIANG_WHITE from "@/assets/images/icon-daxiang-white.png";
import FOOTER_LOGO from "@/assets/images/footer-logo.png";
import { withRouter } from "react-router-dom";
import { Tooltip, Icon, message } from "@ss/mtd-react";
import FOOTER_BG from "@/assets/images/footer-bg.png";
import { CookieButton } from '@sailor/cookie-manage'
import '@sailor/cookie-manage/dist/lib/index.css'

class Footer extends PureComponent {
    jumpToInner = url => {
        this.props.history.push(`/outerpage?targetUrl=${url}`);
    };
    jumpToOuter = url => {
        window.open(url);
    };
    copyMis = () => {
        navigator.clipboard.writeText('charlesip');
        message.success({
            message: 'Copy successfully',
            key: 'copyMis', // 保证只有一个提示
        });
    }
    // 计算属性：判断是否在首页
    get isHomePage() {
        const { pathname } = this.props.location;
        return pathname === "/assets-internal" || pathname === "/";
    }
    render() {
        const isInner = window.location.href.indexOf('assets-internal') > -1;
        return (
            <footer
                className={`footer ${!isInner ? 'outer-footer' : ''}`}
                style={{
                    backgroundImage: this.isHomePage ? `url(${FOOTER_BG})` : ""
                }}
            >
                <div className="container">
                    <div
                        className="content"
                        style={{
                            color: this.isHomePage
                                ? "#ffffff"
                                : "rgba(17, 25, 37, 0.65)"
                        }}
                    >
                        <div className="leftSection" style={{ gap: "30px" }}>
                            <div className="suggestion"></div>
                        </div>
                        <div className="copyright">
                            © 2026 Keeta Brand & Creative Design
                        </div>
                        <div className={`links`}>
                            {!isInner && <CookieButton client='pc' textClass={`cookie-button ${this.isHomePage ? 'white' : ''}`}/>}
                            <a
                                href={`${window.location.href.indexOf('assets-internal') > -1 ? '/assets-internal' : '/assets'}/terms-of-use`}
                                style={{
                                    color: this.isHomePage
                                        ? "#ffffff"
                                        : "rgba(17, 25, 37, 0.65)"
                                }}
                            >
                                Terms of Use
                            </a>
                            {window.location.pathname.includes('/assets-internal') && (
                                <>
                                    <Tooltip
                                        message={
                                             <div className={'toolImgBox'}>
                                                <img src="https://cs-monitor.sankuai.com/api/avatar/charlesip" alt="error" />
                                                <div className={'toolImgBoxRight'}>
                                                    <span className="name">葉招雄(Charles)</span>
                                                    <div>
                                                        <span className="misCount">charlesip</span>
                                                        <Icon onClick={this.copyMis} className="copyIcon" type={'copy-o'} />
                                                    </div>
                                                </div>
                                             </div>
                                        }
                                        placement="top"
                                        color="light"
                                    >
                                        <div className="link-footer linkWithIcon">
                                            Contact Brand team
                                            <img
                                                src={
                                                    this.isHomePage
                                                        ? ICON_DAXIANG_WHITE
                                                        : ICON_DAXIANG
                                                }
                                                alt=""
                                                className="linkIcon"
                                            />
                                        </div>
                                    </Tooltip>
                                    <a
                                        href="https://ss.sankuai.com/px"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link-footer linkWithIcon"
                                        style={{
                                            color: this.isHomePage
                                                ? "#ffffff"
                                                : "rgba(17, 25, 37, 0.65)"
                                        }}
                                    >
                                        Meituan·Pixel
                                        <img
                                            src={
                                                this.isHomePage
                                                    ? ICON_MEITUAN_WHITE
                                                    : ICON_MEITUAN
                                            }
                                            alt=""
                                            className="linkIcon"
                                        />
                                    </a>
                                </>
                            )}
                        </div>
                    </div>

                    {/* <div className="divider"></div> */}
                </div>
            </footer>
        );
    }
}
export default withRouter(Footer);
